const LOAD_TRANSLATIONS = 'dofe-bo/translation/LOAD_TRANSLATIONS'
const LOAD_TRANSLATIONS_SUCCESS = 'dofe-bo/translation/LOAD_TRANSLATIONS_SUCCESS'
const LOAD_TRANSLATIONS_FAIL = 'dofe-bo/translation/LOAD_TRANSLATIONS_FAIL'

const LOAD_DEFAULT_TRANSLATIONS = 'dofe-bo/translation/LOAD_DEFAULT_TRANSLATIONS'
const LOAD_DEFAULT_TRANSLATIONS_SUCCESS = 'dofe-bo/translation/LOAD_DEFAULT_TRANSLATIONS_SUCCESS'
const LOAD_DEFAULT_TRANSLATIONS_FAIL = 'dofe-bo/translation/LOAD_DEFAULT_TRANSLATIONS_FAIL'

const TRANSLATIONS_RESET = 'dofe-bo/translation/TRANSLATIONS_RESET'

const initialState = {
    data: [],
    default: [],
    isLoading: false,
    loaded: false
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_TRANSLATIONS:
            return {
                ...state,
                isLoading: true
            }
        case LOAD_TRANSLATIONS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                loaded: true,
                data: action.result
            }
        case LOAD_TRANSLATIONS_FAIL:
            return {
                ...state,
                isLoading: false,
                loaded: false
            }
        case LOAD_DEFAULT_TRANSLATIONS:
            return {
                ...state,
                isLoading: true
            }
        case LOAD_DEFAULT_TRANSLATIONS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                loaded: true,
                default: action.result
            }
        case LOAD_DEFAULT_TRANSLATIONS_FAIL:
            return {
                ...state,
                isLoading: false,
                loaded: false
            }
        case TRANSLATIONS_RESET:
            return {
                ...state,
                data: [],
                default: [],
                isLoading: false,
                loaded: false
            }
        default:
            return state
    }
}

export function loadTranslations(data) {
    return {
        types: [LOAD_TRANSLATIONS, LOAD_TRANSLATIONS_SUCCESS, LOAD_TRANSLATIONS_FAIL],
        promise: client => client.post('api/translation/load', { data })
    }
}

export function loadDefaultTranslation(data) {
    return {
        types: [LOAD_DEFAULT_TRANSLATIONS, LOAD_DEFAULT_TRANSLATIONS_SUCCESS, LOAD_DEFAULT_TRANSLATIONS_FAIL],
        promise: client => client.post('api/translation/load', { data })
    }
}

export function resetTranslations() {
    return {
        type: TRANSLATIONS_RESET
    }
}
